<template>
  <div>
    <v-card color="grey lighten-4">      
    </v-card>
    <v-container>
      <!-- Form -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="ID"
                    v-model="formSchema.staff_id"
                    :rules="[v => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Name"
                    v-model="formSchema.staff_name"
                    :rules="[v => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Designation"
                    v-model="formSchema.designation"
            
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 md4>
                  <!-- <v-select
                    :items="areaList"
                    label="Organization"
                    item-value="text"
                    hide-details
                    v-model="formSchema.organization"
                  ></v-select> -->
                  <v-text-field
                    label="Organization"
                    v-model="formSchema.organization"
      
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="NID Number"
                    v-model="formSchema.nid_number"
                    :rules="[rules.isNID]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-select
                    :items="salary_cat_list"
                    name="category"
                    label="Select a category"
                    v-model="formSchema.salary_category"
                    v-validate="'required'"
                    item-text="category_name"
                    item-value="id"
                  ></v-select>
                </v-flex>
               
                <v-flex xs12 sm4 md4>
                  <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 1,
                      fieldName: 'join_date',
                      fieldValue: formSchema.join_date,
                      label: 'Joining Date'
                    }"
                    @setValue="setDateValue"
                  ></DatePicker>
                </v-flex>
                <!-- <v-flex xs12 sm4 md4>
                  
                  <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 2,
                      fieldName: 'start_date',
                      fieldValue: formSchema.start_date,
                      label: 'Start Date'
                    }"
                    @setValue="setDateValue"
                    ref="setRangeJoin"
                  ></DatePicker>
                </v-flex> -->
                <v-flex xs12 sm4 md4>
                  <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 3,
                      fieldName: 'end_date',
                      fieldValue: formSchema.end_date,
                      label: 'End Date',
                      disabled:'1'
                    }"
                    @setValue="setDateValue"
                    ref="setRange"
                  ></DatePicker>
                </v-flex>
                 <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Mobile Number"
                    v-model="formSchema.mobile_no"
                    :rules="[rules.phoneNumber]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="E-mail ID"
                    v-model="formSchema.email_id"
                    :rules="[rules.email]"
                  ></v-text-field>
                </v-flex> 
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Present Address"
                    v-model="formSchema.address"
                    
                  ></v-text-field>
                </v-flex>
                 <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Permanent Address"
                    v-model="formSchema.permanent_address"
                    
                  ></v-text-field>
                </v-flex>
                 <v-flex xs12 sm4 md4>	
								     <v-checkbox v-model="formSchema.active" label="Active" :value="isActiveVal"></v-checkbox>
									</v-flex>
             
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              :disabled="!valid"
              @click.native="validateBeforeSubmit"
              >{{ setButtonTitle }}</v-btn
            >
            <v-btn color="error" @click.native="reset">Reset</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <!-- /Form -->
    </v-container>
  </div>
</template>
<script>
/**
 * ---------------------
 *  implements by majeed
 * ---------------------
 */
const commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

import { preFix } from "../../../vuex/api";
import Axios from "axios";
export default {
  components: {
    DatePicker
  },
  props: ["formSchema", "salary_category"],
  data: () => ({
    show: true,
    valid: true,
    dialog: false,
    dialogEditForm: false,
    isActiveVal: 0,
    search: "",
    totalItems: 0,
    loading: true,

    pagination: {
      sortBy: "id",
      descending: true
    },
    
    selected: [],
    search: "",
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name"
      },
      { text: "User Type", align: "left", value: "type_id" },
      { text: "Email", value: "email" }
    ],

    areaList: [
      { id: 1, text: "Dhaka" },
      { id: 2, text: "Chattogram" },
      { id: 3, text: "Khulna" },
      { id: 4, text: "Syhlet" },
      { id: 5, text: "Barisal" },
      { id: 6, text: "Rajshahi" },
      { id: 7, text: "Feni" }
    ],

    delete_id: "",
    row_index: "",
    dialog2: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    select: null,
    instituteList: [],

    salary_cat_list: [],

    rules: {
      email: (v) => {
    
        if (v && v.length > 0) {
          return (
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) || "E-mail must be valid"
          );
        } else {
          return true;
        }
      },
      phoneNumber: (v) => {
        if (v && v.length > 0) {
          return (
            /(\+)?^[+0-9\(\)_.,-]*$/.test(v) ||
            "Phone no. must be valid"
          );
        } else {
          return true;
        }
      },
      isNID: (v) => {
        if (v && v.length > 0) {
          return (
            /^[0-9]*$/.test(v) ||
            "NID no. must be valid"
          );
        } else {
          return true;
        }
      },
    },
    instituteShow: true
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Update Outsource Staff Information"
        : "Add Outsource Staff Information";
    },
    setButtonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {},

  methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
      if(data.fieldName == "join_date"){
        this.formSchema.end_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      var root = this;
      formSchema.join_date = formSchema.join_date == '' ? '' :root.changeFormateYMD(
        formSchema.join_date
        );
      // formSchema.start_date = formSchema.start_date == '' ? '' :root.changeFormateYMD(
      //   formSchema.start_date
      //   );
      formSchema.end_date = formSchema.end_date == 0 ? '' :root.changeFormateYMD(
        formSchema.end_date
        );

      if (this.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "outsource_staff")
            .then(res => {
              	let actionData = {
							message: res.message,
							data: res.data,
							action: "edit",
							status: res.status
							};
							this.close(actionData);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "outsource_staff")
            .then(res => {
              	let actionData = {
							message: res.message,
							data: res.data,
							action: "add",
							status: res.status
							};
							this.close(actionData);
            });
        }
      }
    },
    reset(){
        if(this.formSchema.id > 0)
        {
          close(0)
        }else{
        this.$refs.form.reset();
        }
    },
    close:function(message){
				if(message.status==1)
      	{
          this.$refs.form.reset();
          this.formSchema.join_date = ''
          this.formSchema.start_date = ''
          this.formSchema.end_date = ''
          this.formSchema.id = 0;
				  this.$emit('reloadData', message)
          
				 }				
			},
  },

  watch: {
    salary_category() {
      this.salary_cat_list = this.salary_category;
    }
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/administration/staff_entry/staff_entry_form.vue